// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useSwiper } from "swiper/react";

import image1 from '../images/setup.png'
import image2 from '../images/setup2.png'
import image3 from '../images/setup3.png'
import image4 from '../images/setup4.png'

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import 'swiper/css/autoplay';

function SwiperFunction() {
  const swiper = useSwiper();
  return (
    <>
      <Swiper
        // install Swiper modules
        modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y,]}
        centeredSlides={true}
        pagination={{ clickable: true }}
        onSwiper={(swiper) => console.log(swiper)}
        onSlideChange={() => console.log("slide change")}
        autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
          navigation={true}
          className="mySwiper mx-px sm:mx-10 rounded"
      >
        <SwiperSlide>
          <img
            src={image1}
            alt=""
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={image2}
            alt=""
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
          src={image3}
            alt=""
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={image4}
            alt=""
          />
        </SwiperSlide>
      </Swiper>
    </>
  );
}

export default SwiperFunction;
